<template>
  <div class="wrapper">
    <YesNoRadio
      v-model="active"
      :label="radioLabel"
      :hint="radioHint"
      :class="{ active }"
      class="radio"
      row
    />
    <v-expand-transition>
      <TextArea
        v-if="active"
        :model-value="modelValue"
        :label="textareaLabel"
        :hint="textareaHint"
        :rules="[required]"
        rows="3"
        class="mt-3"
        no-resize
        @update:modelValue="modelValue = $event"
      />
    </v-expand-transition>
  </div>
</template>

<script setup lang="ts">
const { required } = useValidation();

const modelValue = defineModel<string>({ required: true });
defineProps<{
  radioLabel: string;
  textareaLabel: string;
  radioHint?: string;
  textareaHint?: string;
}>();

const active = ref(Boolean(modelValue.value));

watch(active, value => {
  if (!value) {
    modelValue.value = '';
  }
});
</script>

<style scoped lang="scss">
.wrapper {
  margin: var(--space-5) 0;
}
@media (max-width: 850px) {
  .radio {
    transition: padding 0.3s;
    padding-bottom: 0;
    &.active {
      padding-bottom: var(--space-5);
    }
  }
}
</style>